import clsx from "clsx";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BRANDS } from "@/enums/brands";
import { THEME } from "@/enums/profile";
import { GetColors } from "@/utils/library/color";
import { MessageContentPieChart } from "@lula-technologies-inc/wingman/dist/commonjs/models/components";
import { Pie } from "../common/charts/Pie";

const AskPieChart: React.FC<{
  chartData: MessageContentPieChart["chart"];
  themeOverride?: THEME;
  brandOverride?: BRANDS;
}> = ({ chartData, themeOverride }) => {
  const { t } = useTranslation("ask");

  const [title, setTitle] = React.useState<string | undefined>(chartData.title);
  const [data, setData] = React.useState<any[] | undefined>(undefined);

  useEffect(() => {
    if (chartData.title !== title) {
      setTitle(chartData.title);
    }

    const colors = GetColors(chartData.data.length);
    const pieData = chartData.data.map((data, index) => {
      return {
        id: data.label,
        value: data.value,
        label: data.label,
        color: colors[index],
      };
    });

    setData(pieData);
  }, [chartData]);

  if (!data || data.length === 0) {
    return <div>{t("chartFailed")}</div>;
  }

  return (
    <div className={clsx("h-96", "mb-8")}>
      {chartData.title && (
        <h1 className={clsx("text-center", "text-2xl", "font-bold", "mb-4")}>
          {chartData.title}
        </h1>
      )}
      <Pie data={data} themeOverride={themeOverride} />
    </div>
  );
};

export default AskPieChart;
